import { render, staticRenderFns } from "./BildungMapCard.vue?vue&type=template&id=31e248ba&scoped=true&"
import script from "./BildungMapCard.vue?vue&type=script&lang=js&"
export * from "./BildungMapCard.vue?vue&type=script&lang=js&"
import style0 from "./BildungMapCard.vue?vue&type=style&index=0&id=31e248ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e248ba",
  null
  
)

export default component.exports